<nz-form-control [nzValidateStatus]="onValidation ? 'validating' : errorType" [nzErrorTip]="errorMessage">
  <nz-slider [nzTipFormatter]="formatter" [nzStep]="50" [nzMin]="timeMin" [nzMax]="timeMax" [nzMarks]="marks" nzIncluded
    nzRange (nzOnAfterChange)="inputChanged()" [(ngModel)]="value">
  </nz-slider>
</nz-form-control>